document.addEventListener('UpsellProductRendered', function(event) {
    $(".type-detail .up-products").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
        {
            breakpoint: 991,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
            breakpoint: 550,
            settings: {
                slidesToShow: 1,
            }
        },

    ],
});
});